import { render, staticRenderFns } from "./designBgSelect.vue?vue&type=template&id=1e8eec14&scoped=true"
import script from "./designBgSelect.vue?vue&type=script&lang=js"
export * from "./designBgSelect.vue?vue&type=script&lang=js"
import style0 from "./designBgSelect.vue?vue&type=style&index=0&id=1e8eec14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8eec14",
  null
  
)

export default component.exports